const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
const CLOUDINARY_UPLOAD_FOLDER = process.env.REACT_APP_CLOUDINARY_UPLOAD_FOLDER;

export const isCloudinaryConfigured = () =>
  Boolean(CLOUDINARY_CLOUD_NAME && CLOUDINARY_UPLOAD_PRESET);

export const uploadAssetToCloudinary = async (file, resourceType = "auto") => {
  if (!file) {
    throw new Error("No se ha seleccionado ningun archivo.");
  }

  if (!isCloudinaryConfigured()) {
    throw new Error(
      "Falta configurar Cloudinary. Define REACT_APP_CLOUDINARY_CLOUD_NAME y REACT_APP_CLOUDINARY_UPLOAD_PRESET."
    );
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

  if (CLOUDINARY_UPLOAD_FOLDER) {
    formData.append("folder", CLOUDINARY_UPLOAD_FOLDER);
  }

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/${resourceType}/upload`,
    {
      method: "POST",
      body: formData,
    }
  );

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result?.error?.message || "La subida a Cloudinary ha fallado.");
  }

  return {
    secureUrl: result.secure_url || "",
    publicId: result.public_id || "",
  };
};

export const uploadImageToCloudinary = (file) => uploadAssetToCloudinary(file, "image");
export const uploadVideoToCloudinary = (file) => uploadAssetToCloudinary(file, "video");
